import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import { Row, Col } from 'react-flexbox-grid'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'
import Styles from './SolutionDefaultSustainability.css'

@CSSModules(Styles, {allowMultiple:true})
export default class SolutionDefaultSustainability extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'Make the default investment sustainable',
      description: 'Making the default investment option sustainable is the best way to protect people from the financial risks of unsustainable investments.',
      url: config.domain + config.routes.solutionDefaultSustainability
    }
  }

  render() {
    const aysLogo = require( '../../../static/images/AsYouSow_Logo_color.svg' )
    //
    return (
      <div styleName='page'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <div styleName='section-top-faq-background'>
          <ContainerDivs>
            <section styleName='section-top-faq-cell'>
              <div styleName='issue-top-label'>
                SOLUTION: <span>{this.state.title}</span>
              </div>
              <h1 styleName='issue-top-headline'>
                Sustainability should be the standard
              </h1>
              <h2 styleName='issue-top-copy'>
                Making the default investment option sustainable is the best way
                to protect employees from the financial risks of unsustainable investments.
              </h2>
            </section>
          </ContainerDivs>
        </div>
        <ContainerDivs>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={4}>
                <div styleName='issue-second-headline'>
                  <span style={{whiteSpace: 'nowrap'}}>&mdash;&mdash;&mdash;&mdash;</span>
                  <br/>
                  Retirement plan default options carry sustainability risks
                </div>
              </Col>
              <Col xs={12} md={8}>
                <div styleName='issue-second-copy'>
                  <p>
                    If climate and other sustainability risks are embedded in a fund, retirement plan investors aren't just directing trillions of dollars of capital to carbon polluters and weapons makers - they could also be exposed to financial risks from unsustainable investments.
                  </p>
                  <p>
                    Given the scale of the world’s sustainability challenges, employee investors need to make sustainability the default. Retirement plan default options should, at minimum, exclude fossil fuel companies, deforestation-risk agribusiness, gun manufacturers, and high-risk prison industrial complex companies.
                  </p>
                </div>
              </Col>
            </Row>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={6}>
                <div styleName='img-issue'/>
              </Col>
              <Col xs={12} md={6}>
                <div>
                  <div styleName='issue-focus-label'>
                    WHY DEFAULTING TO SUSTAINABILITY MATTERS
                  </div>
                  <div styleName='issue-focus-headline'>
                    Unsustainable investments carry financial risk
                  </div>
                  <div styleName='issue-focus-copy'>
                    <p>
                      Just because the default option is the easiest plan to choose does not mean that it is a safe choice. The default option generally commands the majority of the plan assets: new plan participants often have their contributions automatically allocated to the default, and many never switch.
                    </p>
                    <p>
                      Evidence indicates sustainability-related risk can negatively impact a company’s stock price as well as its reputation. Asset managers have a fiduciary duty to mitigate the financial risks of climate change and other sustainability issues that could impact performance of the companies held in the default fund.
                    </p>
                    <p>
                      <Link
                        to={config.routes.eduCenterFinRisks}
                        title='Financial risks of unsustainable investments'
                        xstrong
                      >
                        Learn more<LinkIcon />
                      </Link>
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </ContainerDivs>
        <div styleName='section-solutions-faq-background'>
          <ContainerDivs>
            <section styleName='section section-solutions-faq'>
              <Row>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <div styleName='issue-solutions-label'>
                      Who we are
                    </div>
                    <img
                      src={aysLogo}
                      alt='As You Sow'
                      styleName='ays-logo'
                    />
                    <div styleName='issue-solutions-copy'>
                      <p>
                        Invest Your Values is a project of <i>As You Sow</i>, the nation’s
                        non-profit leader in shareholder advocacy. Founded in 1992,
                        we harness shareholder power to create lasting change
                        that benefits people, planet, and profit.
                      </p>
                    </div>

                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.about}
                        title='About us'
                        xstrong
                      >
                        About us<LinkIcon/>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <div styleName='issue-faqs-label'>
                      FAQs
                    </div>
                    <div styleName='issue-faqs-headline'>
                      Answers to common questions about how retirement plans and asset managers are financing unsustainable business practices.
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-'}
                        title='Do I have to sacrifice returns in order to invest sustainably?'
                        xstrong
                      >
                        Do I have to sacrifice returns in order to invest sustainably?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-'}
                        title='Why should retirement plans add a sustainable investment option?'
                        xstrong
                      >
                        Why should retirement plans add a sustainable investment option?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.faqs}
                        title='FAQs'
                        xstrong
                      >
                      View all >>
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </section>
            <br/>
            <br/>
          </ContainerDivs>
        </div>
      </div>
    )
  }
}